import React from 'react';

import FacebookPostModule from '@/markdown/modules/FacebookPostModule';
import FacebookShareModule from '@/markdown/modules/FacebookShareModule';
import ButtonModule from '@/markdown/modules/ButtonModule';
import imports from '@/routing/imports';
import Loadable from '@/common/lazy/Loadable';
import InformationDutyStatistics from '@/ui/informationduty/InformationDutyStatistics';
import ArticleBetsCompat from '@/markdown/modules/ArticleBetsCompat';
import { TicketModule } from '@/markdown/modules/TicketModule';
import CharityCounterModule from '@/markdown/modules/CharityCounterModule';
import { StreamingModule } from '@/markdown/modules/StreamingModule';
import ForumComments from '@/markdown/modules/ForumComments';
import { LoginModule } from '@/markdown/modules/LoginModule';
import JackpotsModule from '@/markdown/modules/JackpotsModule';
import CasinoCarouselModule from 'nike-ui/src/components/casino/CasinoCarouselModule';

export default {
    // unifiable
    button: ButtonModule,
    facebook_post: FacebookPostModule,
    facebook_share: FacebookShareModule,
    streaming_module: StreamingModule,

    // channel specific
    bets: ArticleBetsCompat,
    'bets-bet': ArticleBetsCompat,
    'bets-tournament': ArticleBetsCompat,
    casino_tournament_carousel: () => <CasinoCarouselModule />,
    casino_game_console: Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.VegasCasinoGameForArticle }),
    casino_jackpot: () => <JackpotsModule />,
    casino_jackpot_winners: Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.CasinoRecentJackpotsList }),
    casino_thumbnail_single: Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.VegasCasinoGameForArticle }),
    casino_thumbnail_multi: Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.CasinoAllGamesSwiper }),
    casino_top_win: Loadable({ loader: imports.casinoVegas, exp: Exp => Exp.CasinoTopWinsModule }),
    'fbs-counter': () => <CharityCounterModule />,
    forum: () => <ForumComments />,
    login_form: () => <LoginModule />,
    saved_ticket: TicketModule,
    ticketus_ticket: TicketModule,
    user_self_exclusion_statistics: InformationDutyStatistics,

    // mobile specific
    prived_kamosa: Loadable({ loader: imports.clubNike, exp: Exp => Exp.PrivedKamosa })
};
